import { compose, map, reverse, filter, pathEq, prop, assoc } from 'ramda';

const associateVersions = (items, rootIdField, idField = 'id') => compose(
  map(item => {
    const versions = compose(
      reverse,
      filter(pathEq(prop(idField, item), rootIdField.split('.')))
    )(items);

    return assoc('versions', versions)(item);
  })
)(items);

export {
  associateVersions
};
